<template>
  <v-dialog
    :ref="refName"
    v-model="isOpen"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        readonly
        outlined
        :value.sync="dateFormatted"
        :label="label"
        prepend-inner-icon="mdi-calendar"
        class="pointer"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable :min="min">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="isOpen = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="$refs[refName].save(date)">
        OK
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    refName: String,
    label: String,
    value: String,
    minDate: String
  },
  data() {
    return {
      isOpen: false,
      date: '',
      min: ''
    }
  },
  mounted() {
    this.syncDate()
    this.updateMinDate()
  },
  watch: {
    value() {
      this.syncDate()
    },
    date(n) {
      this.$emit('update:date', n)
    },
    minDate() {
      this.updateMinDate()
    }
  },
  computed: {
    dateFormatted() {
      return dayjs(this.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    updateMinDate() {
      if (this.refName === 'enddate') {
        this.min = dayjs(this.minDate)
          .add(1, 'd')
          .format('YYYY-MM-DD')
      } else {
        this.min = dayjs(this.minDate).format('YYYY-MM-DD')
      }
    },
    syncDate() {
      this.date = this.value
    }
  }
}
</script>

<style></style>
